export default __webpack_public_path__ + "static/media/pvilla5-2.6e262484.jpg";